import { useAppSelector } from '../useAppSelector';
import * as lookupSlice from '../../data/lookup.slice';

export const useClientAddressUse = (
  addressUseBC: string | undefined,
): string => {
  const addressUses = useAppSelector(lookupSlice.selectClientAddressUses);
  const addressUse = addressUses.find(
    (s) => s.clientAddressUseBC === addressUseBC,
  );
  return addressUse ? addressUse.clientAddressUseName : '';
};
